/* Dashboard services */

import { API } from '../../Services/Api';

const request = new API();

const serialize = (obj, prefix) => {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      //let k = prefix ? prefix + "." + p  : p
      let k = prefix ? prefix : p;
      let v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? serialize(v, k)
          : encodeURIComponent(k) + '=' + encodeURIComponent(v),
      );
    }
  }
  return str.join('&');
};

export const getLeads = (params) => {
  return request.api.get(`/leads/`, params);
};

export const sendSelectedData = ({query, data}) => {
  return request.api.post(`/leads/tasks/pre_create/?` + serialize(query), data);
};

export const sendTask = ({query, data}) => {
  return request.api.post(`/leads/tasks/?` + serialize(query), data);
};

export const getCitiesListAdmin = ({ q, location}) => {
  let params = { q }
  return  request.api.get(`/leads/cities/${location}/`, params);
}

// export const getNextDashboardInfo = ({ link }) => {
//   const uri = new URL(link);
//   uri.protocol = 'https://';
//   return request.api.get(uri, null);
// };
